export const escalationTypes = [
    'ABUSIVE BEHAVIOUR',
    'EMPLOYEE COMPLAIN',
    'TICKET ISSUE',
    'POLICY VIOLATION',
    'TECHNICAL ISSUE',
    'OTHER'
];

export const priorities = ['low', 'medium', 'high'];

export const text = {
    en: {
        title: "Escalation Group Mapping",
        subtitle: "Configure escalation routing based on type and priority",
        escalationType: "Escalation Type",
        selectType: "Select escalation type",
        issuerGroup: "Issuer Group",
        selectIssuerGroup: "Select issuer group",
        priority: "Priority",
        selectPriority: "Select priority",
        assignedGroup: "Assigned Group",
        selectAssignedGroup: "Select assigned group",
        mapEscalation: "Map Escalation",
        cancel: "Cancel",
        loading: "Loading...",
        mappingSuccess: "Escalation mapping created successfully!",
        mappingFailed: "Failed to create escalation mapping",
        unauthorized: "You must be an admin to perform this action",
        typeRequired: "Escalation type is required",
        issuerGroupRequired: "Issuer group is required",
        priorityRequired: "Priority is required",
        assignedGroupRequired: "Assigned group is required",
        groupId: "Group ID",
        groupName: "Group Name",
        creator: "Creator",
        adminOnly: "Admin Only Feature",
        noGroups: "No groups available",
        loadGroups: "Please create groups first",
        mappingInfo: "Map escalation types to specific groups based on priority levels. This ensures escalations are automatically routed to the appropriate handling team.",
        currentMappings: "Current Mappings",
        currentMappingsSubtitle: "Who escalates to whom",
        noMappings: "No escalation mappings configured yet",
        deleteMapping: "Delete mapping",
        deleteMappingSuccess: "Escalation mapping deleted successfully",
        deleteMappingFailed: "Failed to delete escalation mapping",
        escalatesTo: "escalates to",
    },
    ar: {
        title: "ربط التصعيدات بالمجموعات",
        subtitle: "تكوين توجيه التصعيد بناءً على النوع والأولوية",
        escalationType: "نوع التصعيد",
        selectType: "اختر نوع التصعيد",
        issuerGroup: "مجموعة المُصدر",
        selectIssuerGroup: "اختر مجموعة المُصدر",
        priority: "الأولوية",
        selectPriority: "اختر الأولوية",
        assignedGroup: "المجموعة المعينة",
        selectAssignedGroup: "اختر المجموعة المعينة",
        mapEscalation: "ربط التصعيد",
        cancel: "إلغاء",
        loading: "جاري التحميل...",
        mappingSuccess: "تم إنشاء ربط التصعيد بنجاح!",
        mappingFailed: "فشل في إنشاء ربط التصعيد",
        unauthorized: "يجب أن تكون مسؤولاً لتنفيذ هذا الإجراء",
        typeRequired: "نوع التصعيد مطلوب",
        issuerGroupRequired: "مجموعة المُصدر مطلوبة",
        priorityRequired: "الأولوية مطلوبة",
        assignedGroupRequired: "المجموعة المعينة مطلوبة",
        groupId: "معرف المجموعة",
        groupName: "اسم المجموعة",
        creator: "المنشئ",
        adminOnly: "ميزة خاصة بالمسؤولين",
        noGroups: "لا توجد مجموعات متاحة",
        loadGroups: "يرجى إنشاء المجموعات أولاً",
        mappingInfo: "ربط أنواع التصعيد بمجموعات محددة بناءً على مستويات الأولوية. يضمن ذلك توجيه التصعيدات تلقائيًا إلى الفريق المناسب.",
        currentMappings: "التعيينات الحالية",
        currentMappingsSubtitle: "من يُصعّد إلى من",
        noMappings: "لا توجد تعيينات تصعيد مكونة بعد",
        deleteMapping: "حذف التعيين",
        deleteMappingSuccess: "تم حذف تعيين التصعيد بنجاح",
        deleteMappingFailed: "فشل في حذف تعيين التصعيد",
        escalatesTo: "يُصعّد إلى",
    }
};